
  import { AccountConfirmation, ChangePasswordCommand } from '@/apiclient/apiclient_generated';
  import { NotificationService } from '@/services/notification-service';
  import { AccountModule, AccountStore } from '@/store/account';
  import { Options, Vue } from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';

  @Options({})
  export default class ChangePassword extends Vue {
    private accountStore: AccountModule = AccountStore;

    @Prop() account;
    // accountConfirmations = [AccountConfirmation.None, AccountConfirmation.Mail, AccountConfirmation.MailWithCredentials];

    passError = '';
    password1 = null;
    password2 = null;

    isLoading = false;

    get modalHeader() {
      return 'Reset Password';
    }

    get isFormValid() {
      return this.password1 && this.password2;
    }

    async submitForm() {
      if (this.password1 !== this.password2) {
        this.passError = 'Passwords should be equal';
        return;
      } else {
        this.passError = '';
      }

      this.isLoading = true;

      // accountConfirmation: this.account.accountConfirmationType;

      const command = {
        accountId: this.account.id,
        password: this.password1
      } as ChangePasswordCommand;

      const result = await this.accountStore.changePassword(command);

      this.isLoading = false;

      if (result.isSuccess) {
        NotificationService.NotifySuccess('Password email was successfully changed.');

        this.$emit('close');
      } else {
        NotificationService.NotifyErrors(result.errors);
      }
    }

    cancelForm() {
      this.$emit('cancel');
    }
  }
